import { createFileRoute } from '@tanstack/react-router'

import { OrderHistoryScreen } from '#components/features/orders/order-history-screen'

export const Route = createFileRoute('/_auth/_admin/historico/pedidos')({
  head: () => ({
    meta: [
      { title: 'Histórico de pedidos | UseComanda' },
      {
        name: 'description',
        content: 'Consulte comandas fechadas, totais e itens do período.',
      },
    ],
  }),
  component: OrderHistoryScreen,
})
